export default __webpack_public_path__ + "static/Hack-ZeroSlash-Italic-678bc16b550480d5a3c5c76dbf8c5fb9.woff";